<template>
    <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Revendedor</h5>
                <hr>
				<Toolbar class="p-mb-4">
					<template slot="left">						
						<Button type="button" icon="pi pi-plus" label="Novo" class="p-mr-2" @click="novo"/>												
					</template>
				</Toolbar>
                <DataTable :value="revendedores"  :autoLayout="true"  :filters="filtros" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[10,15,20]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">			
					<template #header>
						<div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
							<div class="p-formgroup-inline">							
								<div class="p-field-radiobutton">
									<RadioButton id="ativo" value="ativo" v-model="filtroSatusRev" @change="listarPorStatus"/>
									<label for="ativo">Ativo</label>
								</div>
								<div class="p-field-radiobutton">
									<RadioButton id="inativo" value="inativo" v-model="filtroSatusRev" @change="listarPorStatus"/>
									<label for="inativo">Inativo</label>
								</div>
								<div class="p-field-radiobutton">
									<RadioButton id="todos" value="todos" v-model="filtroSatusRev" @change="listarPorStatus"/>
									<label for="todos">Todos</label>
								</div>
							</div>
							<span class="p-input-icon-left">
								<i class="pi pi-search" />
								<InputText v-model="filtros['global']" placeholder="Filtrar..." />
							</span>
						</div>
					</template>
					<Column field="id" header="Id" sortable/>		
					<Column field="nome" header="Nome" sortable/>
					<Column field="email" header="E-mail"/>
					<Column field="cpf" header="CPF"/>
					<Column field="telefone" header="Telefone">
						<template #body="slotProps">
							{{ slotProps.data.telefone | maskTelefone }}
						</template>
					</Column>
					<Column field="celular" header="Celular">					
						<template #body="slotProps">
							{{ slotProps.data.celular | maskTelefone }}
						</template>
					</Column>					
					<Column field="cidade.nome" header="Cidade" sortable/>
					<Column field="ativo" header="Ativo" sortable>
						<template #body="slotProps">
							<label v-if="slotProps.data.ativo">Sim</label>
							<label v-if="!slotProps.data.ativo">Não</label>
						</template>
					</Column>
					<Column>
						<template #body="slotProps">
							<Button icon="pi pi-eye" title="Clientes" class="p-button-rounded p-button-success p-mr-2" @click="listarClientes(slotProps.data)"/>
							<Button icon="pi pi-pencil" title="Editar" class="p-button-rounded p-button-primary p-mr-2" @click="editar(slotProps.data)"/>					
						</template>
					</Column>
				</DataTable>
            </div>
        </div>
		<Dialog :visible.sync="exibirDialogCadastro" :header="tituloModal" :modal="true" class="p-fluid" :style="{width: '40vw'}">			
			<div class="p-fluid p-formgrid p-grid">
				<div class="p-field p-col-12 p-md-12">
					<label for="nome">Nome</label>
					<InputText id="nome" v-model.trim="revendedor.nome" required="true" autocomplete="off" maxlength="50"/>
					<small class="p-invalid" v-if="enviandoForm && !revendedor.nome">Informe o nome</small>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label for="cpf">CPF</label>
					<InputMask id="cpf" v-model.trim="revendedor.cpf" mask="999.999.999-99" placeholder="___.___.___-__" required="true" 
						autocomplete="off" maxlength="11"/>
					<small class="p-invalid" v-if="enviandoForm && !revendedor.cpf">Informe o cpf</small>
				</div>
				<div class="p-field p-col-12 p-md-6">
					<label for="email">E-mail</label>
					<InputText id="email" v-model.trim="revendedor.email" required="true" autocomplete="off" maxlength="50"/>
					<small class="p-invalid" v-if="enviandoForm && !revendedor.email">Informe o e-mail</small>
				</div>							
				<div class="p-field p-col-12 p-md-6">
					<label for="tel">Telefone</label>
					<InputMask id="tel" mask="(99) 9999-9999" v-model="revendedor.telefone" placeholder="(  ) ____-____" autocomplete="off" />					
				</div>						
				<div class="p-field p-col-12 p-md-6">
					<label for="celular">Ceular</label>
					<InputMask id="celular" mask="(99) 99999-9999" v-model="revendedor.celular" placeholder="(  ) _____-____" autocomplete="off" />					
				</div>						
				<div class="p-field p-col-12 p-md-6">
					<label for="email">Estado</label>
					<Dropdown id="estado" @change="listarCidades" v-model="revendedor.estado.id" :options="estados" optionLabel="uf" 
						optionValue="id" placeholder="Selecione" :filter="true" :showClear="true" appendTo="body"/>
				</div>							
				<div class="p-field p-col-12 p-md-6">
					<label for="email">Cidade</label>
					<Dropdown id="cidade" v-model="revendedor.cidade" :options="cidades" required="true"
						optionLabel="nome" placeholder="Selecione" :filter="true" :showClear="true" appendTo="body"/>
					<small class="p-invalid" v-if="enviandoForm && !revendedor.cidade.id">Selecione uma cidade</small>
				</div>
			</div>		
			<div class="p-fluid p-formgrid p-grid" v-if="revendedor.id != null">
				<div class="p-field p-col">
					<div class="p-field-checkbox">
                        <Checkbox v-model="revendedor.ativo" :binary="true"/>
                        <label>Ativo</label>
                    </div>
                </div>
			</div>		
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="fecharModal"/>
				<Button label="Salvar" icon="pi pi-check" @click="salvar"/>
			</template>
		</Dialog>
		<Dialog :visible.sync="exibirDialogClientes" header="Clientes" :modal="true" class="p-fluid" :style="{width: '60vw'}">
			<DataTable :value="clientes"  :autoLayout="true"  :filters="filtrosClientes" :paginator="true" :rows="10"
					paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
					:rowsPerPageOptions="[5,10,15]" currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
					class="p-datatable-sm p-datatable-striped">			
					<template #header>
						<div class="table-header p-d-flex p-flex-column p-flex-md-row p-jc-md-between">
							<div class="p-col-9">
								{{ revendedor.nome }}
							</div>							
							<span class="p-input-icon-left">
								<i class="pi pi-search" />
								<InputText v-model="filtrosClientes['global']" placeholder="Filtrar..." />
							</span>
						</div>
					</template>		
					<Column field="id" header="Id" sortable></Column>
					<Column field="nome" header="Nome" sortable></Column>
					<Column field="cnpj" header="CNPJ" sortable></Column>				
					<Column field="seguimento" header="Segmento" sortable></Column>
					<Column field="dataCadastro" header="Cadastro" sortable></Column>	
					<Column field="status" header="Status" sortable>
						<template #body="slotProps">                                    
							<div>   							                                     
								<span class="p-badge p-badge-lg p-badge-danger" title="Cliente Bloqueado" v-if="slotProps.data.status == 2" >
									<i style="color:#F9B720" class="pi pi-lock" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-secondary" title="Cliente Inativo" v-else-if="slotProps.data.status == 0" >
									<i class="pi pi-power-off" ></i>                                       
								</span>
								<span class="p-badge p-badge-lg p-badge-success" title="Cliente Ativo" v-else>                                          
									<i class="pi pi-lock-open"></i>
								</span>                                        
							</div>
						</template>	
					</Column>				
				</DataTable>
		</Dialog>
    </div>
</template>

<script>

import Revendedor from '@/model/Revendedor';
import RevendedorService from '@/service/RevendedorService';
import EmpresaService from '@/service/EmpresaService.js'
import { exibirMensagem } from '@/global';
import { mapGetters } from 'vuex';

export default {
	revendedorService: null,
	empresaService: null,
    data () {
        return {
			filtroSatusRev: 'ativo',
			tituloModal: 'Novo Revendedor',
			enviandoForm: false,
			exibirDialogClientes: false,
			exibirDialogCadastro: false,
            revendedores: [],
			revendedor: new Revendedor(),
			filtros: {},
			filtrosClientes: {},			
			cidades: [],
            estados: [],
			clientes: [],
        }
    },
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao','getPermissoes']),
		salvar() {
			this.enviandoForm = true;
			if(this.revendedor.nome == '' || this.revendedor.email == '' 
				|| this.revendedor.cpf == '' || this.revendedor.cidade.id == null) {
				return;
			}
			let requisicao = {				
				usuarioRequisicao: {...this.getDadosRequisicao()},
				revendedor: this.revendedor,
			}
			this.revendedorService.salvar(requisicao)
				.then(resp => {						
					exibirMensagem(this, resp);
					this.fecharModal();			
					this.listar();		
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		listarPorStatus() {
			if(this.filtroSatusRev == 'ativo' || this.filtroSatusRev == 'inativo') {
				this.listar();
			} else {
				this.listarTodos();
			}
		},	
		listar() {
			let requisicao = {				
				usuarioRequisicao: {...this.getDadosRequisicao()},
				ativo: (this.filtroSatusRev == 'ativo' ? true : false),
			}
			this.revendedorService.listar(requisicao)
				.then(resp => {			
					this.revendedores = resp.data;										
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		listarTodos() {
			let requisicao = {				
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.revendedorService.listarTodos(requisicao)
				.then(resp => {			
					this.revendedores = resp.data;							
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		listarCidades() {
			this.empresaService.listarCidades(this.revendedor.estado.id)
				.then(resp => {					
					this.cidades = resp.data;
					this.exibirDialogCadastro = true;
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		listarEstados() {
			this.empresaService.listarEstados()
				.then(resp => {					
					this.estados = resp.data;					
				})
				.catch(erro => {exibirMensagem(this, erro)});
		},
		listarClientes(revendedor) {
			this.revendedor = revendedor;
			let requisicao = {				
				idRevendedor: revendedor.id,
				usuarioRequisicao: {...this.getDadosRequisicao()}
			}
			this.revendedorService.listarClientes(requisicao)
				.then(resp => {			
					this.clientes = resp.data;	
					this.exibirDialogClientes = true;						
                })
                .catch(erro => {exibirMensagem(this, erro)});
		},
		novo() {
			this.revendedor = new Revendedor();
			this.exibirDialogCadastro = true;
			this.tituloModal = 'Novo Revendedor';
		},
		editar(revendedor) {
			this.tituloModal = 'Editar Revendedor';
			this.revendedor = {...revendedor};
			this.listarCidades();
		},
		excluir() {

		},
		fecharModal() {
			this.exibirDialogCadastro = false;
			this.revendedor = new Revendedor();
		},		
	},
	created() {
		this.revendedorService = new RevendedorService();
		this.empresaService = new EmpresaService();
		this.listar();
		this.listarEstados();
	}
}
</script>

<style>
</style>